import { render, staticRenderFns } from "./DetailCouncil.vue?vue&type=template&id=345c84c6&scoped=true"
import script from "./DetailCouncil.vue?vue&type=script&lang=js"
export * from "./DetailCouncil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345c84c6",
  null
  
)

export default component.exports